export const ru = {
    arrivalWarning: 'Дата прибытия отличается от даты вылета',
};
